import { render } from "./Loading.vue?vue&type=template&id=b9f33958&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=b9f33958&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9f33958"]])

export default __exports__